export default "/_next/static/images/a2c4d2359472ca778a259298dfa37510.jpg";